<template>
  <article class="relative theme-thumbnail">
    <button
      type="button"
      class="theme-content grid border-2 border-base-30 rounded"
      @click.prevent="$emit('clickTheme')"
    >
      <div
        class="bg-base-color col-start-1 row-start-1 w-full h-full rounded"
        :style="{ backgroundColor: theme.baseColour }"
      ></div>
      <div
        v-if="theme?.backgroundImage"
        class="bg-image col-start-1 row-start-1 bg-cover w-full h-full bg-no-repeat bg-center rounded"
        :style="{ backgroundImage: `url(${theme.backgroundImage?.large})`, opacity: theme.visibility / 100 }"
      ></div>
      <div class="color-palette col-start-1 row-start-1">
        <svg
          class="w-full absolute bottom-2"
          width="152"
          height="33"
          viewBox="0 0 152 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.25 9.5C0.25 7.42893 1.92893 5.75 4 5.75H24.8C26.8711 5.75 28.55
           7.42893 28.55 9.5V32.25H4C1.92893 32.25 0.25 30.5711 0.25 28.5V9.5Z"
            :fill="colorPalettes[0]"
            stroke="#EBEBEB"
            stroke-width="0.5"
          />
          <path
            d="M31.05 17.5C31.05 15.4289 32.729 13.75 34.8 13.75H55.6C57.6711
           13.75 59.35 15.4289 59.35 17.5V32.25H31.05V17.5Z"
            :fill="colorPalettes[1]"
            stroke="#EBEBEB"
            stroke-width="0.5"
          />
          <path
            d="M61.8501 4.5C61.8501 2.42893 63.529 0.75 65.6001
           0.75H86.4001C88.4712 0.75 90.1501 2.42893 90.1501 4.5V32.25H61.8501V4.5Z"
            :fill="colorPalettes[2]"
            stroke="#EBEBEB"
            stroke-width="0.5"
          />
          <path
            d="M92.6499 12.5C92.6499 10.4289 94.3288 8.75 96.3999
           8.75H117.2C119.271 8.75 120.95 10.4289 120.95 12.5V32.25H92.6499V12.5Z"
            :fill="colorPalettes[3]"
            stroke="#EBEBEB"
            stroke-width="0.5"
          />
          <path
            d="M123.45 20.5C123.45 18.4289 125.129 16.75 127.2 16.75H148C150.071
           16.75 151.75 18.4289 151.75 20.5V28.5C151.75 30.5711 150.071 32.25 148 32.25H123.45V20.5Z"
            :fill="colorPalettes[4]"
            stroke="#EBEBEB"
            stroke-width="0.5"
          />
        </svg>
      </div>
      <div
        class="theme-name col-start-1 text-center
      row-start-1 font-bold flex justify-center items-center"
      >
        <span
          class="truncate max-w-32 transform -translate-y-2"
          :title="theme?.themeName"
          :style="{ fontFamily: theme?.fontFamily, color: theme?.textColour }"
        >
          {{ theme?.themeName }}
        </span>
      </div>
      <div class="theme-logo relative col-start-1 row-start-1">
        <img v-if="theme?.logo" :src="theme?.logo?.thumbnail" class="max-w-11 absolute top-2 right-2">
        <div v-else class="max-w-11 absolute top-0 right-2">
          <aha-logo
            v-if="isColorLight"
            width="156"
            height="26"
            viewBox="0 0 9600 1602"
            :use-default-color="false"
            class="img-logo-white max-w-11 text-white-100"
          />
          <aha-logo
            v-else
            width="156"
            height="26"
            viewBox="0 0 9600 1602"
            class="img-logo-default max-w-11"
          />
        </div>
      </div>
    </button>
    <span v-if="showContextMenu" class="theme-context-menu absolute top-2 right-2">
      <ThemeContextMenu>
        <template #icon>
          <button
            type="button"
            class="theme-context-menu-button transform rotate-90 w-5 h-5 invisible hover:visible
            inline-flex justify-center items-center rounded-sm bg-base-0"
          >
            <aha-icon
              name="kebab-menu"
              width="16"
              height="16"
              viewBox="0 0 14 14"
            />
          </button>
        </template>
        <template #items>
          <slot name="context-menu-items">
          </slot>
        </template>
      </ThemeContextMenu>
    </span>
  </article>
</template>
<script>
import ThemeContextMenu from '@/components-v2/presentation-editor/side-right/right-nav/ThemeContextMenu.vue'
import Util from '@/util'
import { isColorLight } from '@/utils/color.utils'

export default {
  components: {
    ThemeContextMenu,
  },
  props: {
    theme: {
      type: Object,
      default: () => {},
    },
    showContextMenu: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    colorPalettes() {
      return this.theme?.colorPalette?.colors || []
    },
    isColorLight() {
      return isColorLight(this.theme?.textColour)
    },
  },
  mounted() {
    if (!this.theme?.fontFamily) return
    Util.importFont(this.theme?.fontFamily)
  },
}
</script>
<style scoped lang="scss">
.theme-thumbnail {
    &:hover, &:focus-within, & > .theme-content:focus-visible  {
        .theme-context-menu .theme-context-menu-button, ~ .theme-context-menu .theme-context-menu-button {
            @apply visible;
        }
    }
}

.theme-content {
    width: 100%;
    aspect-ratio: 16 / 9;
}

button.theme-content:hover {
  // Out current tailwind doesn't support outline-color
  // So I need to put the color hex code here to make it work
  outline: 3px solid #348EF6;
}

button:focus-visible {
  outline: 3px solid #89BEFA;
}
</style>
